import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"

import { cn } from "@/lib/utils"

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, ...props }, ref) => {
  const progressValue = value ?? 0;
  
  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn(
        "relative h-2 w-full overflow-hidden rounded-full bg-green-500/20",
        className,
        {
          "bg-red-500/20": progressValue < 25,
          "bg-orange-500/20": progressValue >= 25 && progressValue < 100,
          "bg-green-500/20": progressValue === 100,
        }
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className={`h-full w-full flex-1  transition-all ${
          progressValue < 25 
                ? 'bg-red-500'
                : progressValue < 100
                ? 'bg-orange-500'
                : 'bg-green-500'
        }`}
        style={{ transform: `translateX(-${100 - progressValue}%)` }}
      />
    </ProgressPrimitive.Root>
  );
})
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
